import { FunctionComponent } from 'react'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DayJsUtils from '@date-io/dayjs'

export const MuiDatePickerUtilsProvider: FunctionComponent = ({ children }) => (
  <MuiPickersUtilsProvider utils={DayJsUtils} children={children} />
)
